module.exports = __webpack_public_path__ + "static/media/dajianshan5.06c467b4.webp";